/**
 * Resolves the API base URL for the current runtime.
 *
 * Web build → reads REACT_APP_BACKEND_URL from .env (preview / staging / prod).
 * Native build (Capacitor iOS/Android) → always points at production
 *                                        unless REACT_APP_MOBILE_API_URL overrides.
 *
 * Why: the bundled web assets ship inside the .ipa / .aab so we can't rely on
 * the dev-server proxy; the native shell must talk to a real https endpoint.
 */
import { Capacitor } from '@capacitor/core';

const WEB_URL = process.env.REACT_APP_BACKEND_URL || '';
const MOBILE_URL = process.env.REACT_APP_MOBILE_API_URL || 'https://book.clayworks.space';

export const isNativeApp = () => {
  try {
    return Capacitor?.isNativePlatform?.() === true;
  } catch (_e) {
    return false;
  }
};

export const getApiBase = () => (isNativeApp() ? MOBILE_URL : WEB_URL);

// tel: links work in the native app and in mobile/touch browsers, but do
// nothing useful on desktop web — gate call buttons on this instead of
// isNativeApp() alone so mobile-web users aren't left without a call option.
export const canPlaceCall = () => {
  if (isNativeApp()) return true;
  try {
    return window.matchMedia?.('(pointer: coarse)')?.matches === true;
  } catch (_e) {
    return false;
  }
};

// Razorpay key: same key works for both web + native. Centralised here so
// any future per-platform override has a single edit point.
export const getRazorpayKeyId = () => process.env.REACT_APP_RAZORPAY_KEY_ID || '';
